export const recover = [
  '0 0 32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.4" stroke="currentColor" d="M16.636 8.5v7.5"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.4" stroke="currentColor" d="M23.136 19.75l-6.5-3.75"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.4" stroke="currentColor" d="M7.855 11.578h-6.25v-6.25"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="2.4" stroke="currentColor" d="M6.918 25.719c1.923 1.924 4.373 3.235 7.040 3.766s5.433 0.26 7.946-0.781c2.513-1.040 4.661-2.803 6.173-5.064s2.318-4.92 2.318-7.64-0.807-5.379-2.318-7.64c-1.511-2.261-3.66-4.024-6.173-5.064s-5.278-1.312-7.946-0.781-5.118 1.842-7.040 3.766l-5.313 5.297"></path>

`,
]
